import { render, staticRenderFns } from "./incomeandexpenditure.vue?vue&type=template&id=101abb95"
import script from "./incomeandexpenditure.vue?vue&type=script&lang=js"
export * from "./incomeandexpenditure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports